



























import RkDropdownItem from './rk-dropdown-item.vue';
import Vue from 'vue';
import { Component, Prop, PropSync, Ref } from 'vue-property-decorator';

interface Option {
  value: string | number;
  name: string | number;
}

@Component({
  components: { RkDropdownItem },
})
export default class RkDropdown extends Vue {
  @Ref('popper') private readonly popper!: any;
  @Prop({ default: 'click' }) private trigger!: string;
  @Prop({ default: '180px' }) private width!: string;
  @Prop({ default: false }) private show!: boolean;
  @Prop({ default: false }) private search!: boolean;
  @Prop({ default: () => [] }) private options!: Option[];
  private searchString: string = '';
  private get searchResult() {
    return this.options.filter((item: Option) =>
    `${item.name}`.indexOf(this.searchString) !== -1);
  }
  private handleClick(i: Option) {
    this.$emit('click', i);
    this.popper.doClose();
  }
}
